// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"1f0a33e3","90":"8f4f9e6a","268":"805d678c","284":"dc3ba958","409":"c09a2c52","453":"5e459136","950":"949bf3eb","989":"39ea6209"}[chunkId] + ".chunk.js";
};